import { Client } from 'src/Redux/api/clientsApi.ts'

type ContactField = 'offerContactName' | 'offerContactPosition'

export interface OfferContact {
  offerContactName?: string
  offerContactPosition?: string
}

export interface ContactConflict {
  field: ContactField
  label: string
  current: string
  next: string
}

export interface ContactSyncPlan {
  silentUpdates: OfferContact
  conflicts: ContactConflict[]
}

const CONTACT_FIELD_LABELS: Record<ContactField, string> = {
  offerContactName: 'ФИО',
  offerContactPosition: 'Должность',
}

export const planClientContactSync = (
  client: Pick<Client, ContactField> | undefined,
  contact: OfferContact,
): ContactSyncPlan => {
  const plan: ContactSyncPlan = { silentUpdates: {}, conflicts: [] }

  if (!client) return plan
  ;(Object.keys(CONTACT_FIELD_LABELS) as ContactField[]).forEach((field) => {
    const next = contact[field]?.trim()
    const current = client[field]?.trim()

    if (!next || next === current) return

    if (!current) {
      plan.silentUpdates[field] = next
      return
    }

    plan.conflicts.push({
      field,
      label: CONTACT_FIELD_LABELS[field],
      current,
      next,
    })
  })

  return plan
}

export const applyConflicts = (plan: ContactSyncPlan): OfferContact =>
  plan.conflicts.reduce<OfferContact>(
    (updates, conflict) => ({ ...updates, [conflict.field]: conflict.next }),
    { ...plan.silentUpdates },
  )
